import React from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";
import educationBanner from "../../assets/images/skill.svg";

export default function Education() {
  if (educationInfo.display) {
    return (
      <div className="education-section" id="education">
        <div className="education-banner">
          <div className="education-banner-text">
            <h1 className="education-heading">
              <i className="fas fa-graduation-cap section-heading-icon" aria-hidden="true"></i>
              {educationInfo.title || "Education"}
            </h1>
            <p className="subTitle education-text-subtitle">
              {educationInfo.subtitle || "Basic Qualification and Certifications"}
            </p>
          </div>
          <div className="education-banner-image">
            <img alt="Education banner" src={educationBanner}></img>
          </div>
        </div>
        <div className="education-card-container">
          {educationInfo.schools.map((school, index) => (
            <EducationCard key={index} school={school} />
          ))}
        </div>
      </div>
    );
  }
  return null;
}
